export default {
    brush: {
        title: 'Cepillo',
        brushHardness: 'Dureza del pincel',
        brushSize: 'Tamaño del pincel',
        brushColor: 'Color del pincel',
    },
};
